import { Search, Filter } from 'lucide-react'
import { Input } from '@/components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { OwnerFilterCombobox } from '@/components/common/OwnerFilterCombobox'
import { ADMIN_PLAN_STATUS_OPTIONS } from '@/api/adminPlans'
import type { ApiPlanStatus } from '@/types'

interface AssortmentAccessFiltersProps {
  searchInput: string
  onSearchChange: (value: string) => void
  statusFilter: ApiPlanStatus | 'all'
  onStatusFilterChange: (value: ApiPlanStatus | 'all') => void
  ownerFilter: string | null
  onOwnerFilterChange: (value: string | null) => void
}

export function AssortmentAccessFilters({
  searchInput,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  ownerFilter,
  onOwnerFilterChange,
}: AssortmentAccessFiltersProps) {
  return (
    <div className="flex items-center gap-3 rounded-lg border border-border bg-card p-3">
      {/* Search Input */}
      <div className="relative flex-1 max-w-[352px]">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          placeholder="Search plans..."
          value={searchInput}
          onChange={e => onSearchChange(e.target.value)}
          className="pl-9 bg-muted/50"
        />
      </div>

      {/* Filter Icon */}
      <Filter className="h-6 w-6 text-muted-foreground" />

      {/* Status Filter */}
      <Select
        value={statusFilter}
        onValueChange={value =>
          onStatusFilterChange(value as ApiPlanStatus | 'all')
        }
      >
        <SelectTrigger className="w-[160px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {ADMIN_PLAN_STATUS_OPTIONS.map(option => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {/* Owner Filter */}
      <OwnerFilterCombobox
        value={ownerFilter}
        onValueChange={onOwnerFilterChange}
      />
    </div>
  )
}
